import { useOne, useTranslation, useUpdate } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { useNavigate } from "react-router-dom";
import { IEInvoiceSetting, IEInvoiceSettingForm } from "interfaces";
import toast from "react-hot-toast";
import { FullScreenLoading } from "components/fullScreenLoading";
import { WPSEditEInvoiceSettingForm } from "../components/editEInvoiceSettingForm";

const WPSEditEInvoicesSettings = () => {
  const { translate } = useTranslation();
  const breadcrumbItems = [
    {
      label: translate("menu-einvoices"),
      href: "/organization/einvoice",
    },
    {
      label: translate("edit"),
      href: "/organization/einvoice/edit",
    },
  ];
  const { mutate, isLoading: isUpdating } = useUpdate();
  const navigate = useNavigate();

  const { data, isFetching } = useOne<IEInvoiceSetting>({
    resource: "organization/einvoice-settings",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const onSubmit = (values: IEInvoiceSettingForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "organization/einvoice-settings",
        id: "",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
          sepay_provider_account_id: eInvoiceData?.sepay_provider_account_id,
          sepay_template_code: eInvoiceData?.sepay_template_code,
          sepay_invoice_series: eInvoiceData?.sepay_invoice_series,
        },
      },
      {
        onSuccess: () => {
          toast.success("Edit successfully");
          navigate("/organization/einvoice");
        },
      },
    );
  };

  const eInvoiceData = data?.data ?? null;

  if (isFetching) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />
      {eInvoiceData && (
        <WPSEditEInvoiceSettingForm
          onSubmit={onSubmit}
          defaultValues={eInvoiceData}
        />
      )}
    </div>
  );
};

export default WPSEditEInvoicesSettings;
